import type { FaireProductEntity } from "../../entity_types/product";

export const p_dwucw6bht2: FaireProductEntity = {
  token: "p_dwucw6bht2",
  type: "product",
  name: "7 Chakra™ Organic Wellness Tea",
  brandToken: "b_5bw8e8irqb",
  brandName: "Boulder Tea Company",
  imageUrl:
    "https://cdn.faire.com/fastly/8d2079c18e05790b8cd94a0b56dbf6a3877edacc0c86c98097241a4f28e5a8e2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/908ad1bcd4c3d9e94c899f0f6a4d5d01985b05a8672fce49863c74755ab6cb91.jpeg",
  ],
  priceDollars: 15.24,
  description:
    "7 Chakra™ organic herbal tea ‘balances and supports intrinsic human energies’ (Chakras). Most of these tonifying, balancing herbs are indigenous to the Rocky Mountain region. Each puts forth an exquisite, revitalizing boost of solid botanical goodness. Caffeine Free. \nIngredients: Elderberries (organic), Nettle Leaf (organic), Hawthorn Leaf and Flowers (organic), Blackberry Leaf (organic), Dandelion Root (organic), Spearmint Leaf (organic), Rosehips (organic).",
  tags: [],
  msrpDollars: 21.82,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:57:51.628Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
